<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.reports'), $t('reports.saleStatistics')]">
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="110px"
      >
        <el-form-item
          :label="$t('text.createAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.date')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-row>
          <el-col :span="3">
            <el-radio-group
              v-model="searchForm.statisticsType"
              @change="changeType"
            >
              <el-radio label="shop" style="margin-right: 10px">
                {{ $t("menu.shops") }}
              </el-radio>
              <el-radio label="user" style="margin-right: 10px">
                {{ $t("reports.userName") }}
              </el-radio>
            </el-radio-group>
          </el-col>

          <el-col :span="21">
            <el-checkbox-group
              v-model="searchForm.shopIds"
              v-if="searchForm.statisticsType == 'shop'"
            >
              <el-checkbox
                v-for="shop of shops"
                :key="shop.id"
                :label="shop.name"
              >
                {{ shop.name }}
              </el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group
              v-model="searchForm.userIds"
              v-if="searchForm.statisticsType == 'user'"
            >
              <el-checkbox
                v-for="user of users"
                :key="user.id"
                :label="user.name"
              >
                {{ user.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <!-- <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky> -->
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          v-if="searchForm.statisticsType == 'shop'"
          field="name"
          :title="$t('menu.shops')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            {{ row.name }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="searchForm.statisticsType == 'user'"
          field="name"
          :title="$t('reports.userName')"
          min-width="100px"
        />
        <vxe-table-column
          field="amount"
          :title="$t('reports.saleAmount')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            <span>{{ row.amount | currency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payAmount"
          :title="$t('reports.payAmount')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            <span>{{ row.payAmount | currency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remainPayAmount"
          :title="$t('reports.remainPayAmount')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            <span>{{ row.remainPayAmount | currency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remainDepositAmount"
          :title="$t('reports.remainDepositAmount')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            <span>{{ row.remainDepositAmount | currency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="rentQuantity"
          :title="$t('reports.rentQuantity')"
          min-width="100px"
        />
        <vxe-table-column
          field="serviceQuantity"
          :title="$t('reports.serviceQuantity')"
          min-width="100px"
        />
        <vxe-table-column
          field="availableQuantity"
          :title="$t('reports.availableQuantity')"
          min-width="100px"
        />
        <vxe-table-column
          field="customQuantity"
          :title="$t('reports.customQuantity')"
          min-width="100px"
        />
      </vxe-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import DateRange from "@/components/DateRange";
import Shop from "@/api/shop";
import User from "@/api/user";

import Workbench from "@/api/workbench";

export default {
  mixins: [page, table.search],
  components: { DateRange },
  data() {
    return {
      searchForm: {
        createAtStartAt: null,
        createAtEndAt: null,
        statisticsType: "shop",
        shopIds: [],
        userIds: [],
      },
      shops: [],
      users: [],
      searchDoing: false,
      records: [],
      total: [],
      records: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    axios.all([Shop.findByTenantId(), User.findByTenantId()]).then(
      axios.spread(function (shops, users) {
        if (shops.status == 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        if (users.status == 200) {
          self.users = users.data.filter(
            (u) =>
              (u.voidAt == null && u.authorizeW == true) || u.voidAt != null
          );
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    changeType() {
      this.searchForm.shopIds = [];
      this.searchForm.userIds = [];
      this.records = [];
    },
    clickDetail(row) {
      const self = this;
      let query = Util.deleteObjValueIsNull(self.searchForm);
      query["supplierId"] = row.supplierId;
      self.$router.push({
        name: "fnReportsSupplierContributionStatisticsDetail",
        query: query,
      });
    },
    search() {
      const self = this;
      if (self.searchForm.createAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("text.createAt")]),
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Workbench.saleStatistics(Util.deleteObjValueIsNull(self.searchForm)).then(
        function (res) {
          self.loading = false;
          if (res.status === 200) {
            self.records = res.data;
          } else {
            self.sysError();
          }
        }
      );
    },

    // download() {
    //   const self = this;

    //   if (self.records.length == 0) {
    //     this.$message({
    //       message: self.$t("text.noData"),
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   Workbench.scheduleStatistics(Util.deleteObjValueIsNull(self.searchForm)).then(
    //     function (res) {
    //       if (res.status === 200) {
    //         self.$message({
    //           message: self.$t("prompt.downloadPrompt"),
    //           type: "success",
    //         });
    //         self.checkedRows = [];
    //         self.$eventHub.$emit("emitDownLoad");
    //       } else {
    //         self.$message.error(self.$t("prompt.downloadErr"));
    //       }
    //     }
    //   );
    // },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>